import React from 'react';
import { categoryData } from './categoryData';
import classNames from 'classnames';
import Typewriter from 'typewriter-effect';
import StoryAudio from '../Journey/StoryAudio';
import Timeline from '../Journey/Timeline';
const StoryGlobe = React.lazy(() => import('./../Journey/StoryGlobe'));

export default function CategoryJourney(props) {
  const { category, setCategory, categoryBackground } = props;
  const [activeStoryIndex, setActiveStoryIndex] = React.useState(0);
  const [nextStoryIndex, setNextStoryIndex] = React.useState(null);
  React.useEffect(() => {
    let timeoutId = null;

    if (nextStoryIndex !== null && nextStoryIndex !== activeStoryIndex) {
      timeoutId = setTimeout(() => {
        setActiveStoryIndex(nextStoryIndex);
        setNextStoryIndex(null);
      }, 500);
    } else {
      setNextStoryIndex(null);
    }

    return () => clearTimeout(timeoutId);
  }, [
    activeStoryIndex,
    nextStoryIndex,
    setNextStoryIndex,
    setActiveStoryIndex,
  ]);

  React.useEffect(() => {
    if (nextStoryIndex < 0 || nextStoryIndex >= categoryData[category].length) {
      setCategory(null);
    }
  }, [nextStoryIndex, category, setCategory]);

  React.useEffect(() => {
    let direction = 0;
    let timeoutId = null;

    function onWheel(event) {
      const { deltaY } = event;

      if (deltaY >= 50) direction = 1;
      if (deltaY <= -50) direction = -1;

      if (!!direction) {
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          setNextStoryIndex(activeStoryIndex + direction);
          direction = 0;
        }, 50);
      }
    }

    window.addEventListener('wheel', onWheel);
    return () => {
      window.removeEventListener('wheel', onWheel);
      clearTimeout(timeoutId);
    };
  }, [activeStoryIndex, setNextStoryIndex]);

  const isTransitioning = nextStoryIndex !== null;

  const story = categoryData[category][activeStoryIndex];
  const journeyClassNames = classNames('journey', {
    '--journey-fade-out': isTransitioning,
  });

  const backgroundCategory = `${category}Background`;
  const backgroundVideo = categoryData[backgroundCategory];

  const byline = `by ${story.reporter}.${
    story.photoCredit
      ? ` ${story.photoCreditNoun || 'Photo'} Credit: ${story.photoCredit}.`
      : ''
  }`;

  return (
    <div className={journeyClassNames}>
      <div className='journey-background'>
        <video autoPlay muted loop>
          <source src={backgroundVideo} type='video/mp4' />
        </video>
      </div>
      <div className='journey-overlay' />
      <div className='journey-globe'>
        <React.Suspense fallback={<React.Fragment />}>
          <StoryGlobe country={story.country} />
        </React.Suspense>
      </div>
      <div className='journey-content'>
        {!isTransitioning && (
          <Typewriter
            wrapperClassName='story-title'
            options={{
              wrapperClassName: 'Typewriter__wrapper story-title',
              delay: 75,
            }}
            onInit={(typewriter) => typewriter.typeString(story.title).start()}
          />
        )}
        <div className='content-container'>
          <p className='story-byline'>{byline}</p>
          {story.quote && (
            <blockquote className='story-quote'>{story.quote}</blockquote>
          )}
          {story.summary && (
            <div className='story-summary'>
              <div className='heading'>
                <h3 className='heading-text'>what you need to know</h3>
              </div>

              <ul className='story-summary-list'>
                {story.summary.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className='button-container'>
          <a href={story.link} className='story-link'>
            <button className='read-button'>READ MORE</button>
          </a>
        </div>
      </div>

      {story.audio && (
        <div className='journey-audio'>
          <StoryAudio audioSrc={`audio/${story.audio}`} />
        </div>
      )}
      <Timeline
        stories={categoryData[category]}
        activeStoryIndex={activeStoryIndex}
        setNextStoryIndex={setNextStoryIndex}
      />
    </div>
  );
}
